import React, { useRef, useState } from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import Editor from "@monaco-editor/react";
import { Box, Grid } from "@mui/material";
import * as Sentry from "@sentry/react";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

export const JsonConfigInput = ({
  config,
  onChange,
}: ConfigurationInputProps) => {
  const [jsonData, setJsonData] = useState<string>(
    JSON.stringify(config.value, undefined, 2)
  );

  const editorRef = useRef(null);

  // validate json object
  const [validate, setValidate] = useState<boolean>(false);

  const parseOptionsInput = () => {
    if (jsonData.length < 1) {
      // if update json to nothing (empty)
      onChange({}); // set empty object
      setValidate(true);
    } else {
      try {
        const optionsData = JSON.parse(jsonData); // turn to Json object
        if (optionsData && typeof optionsData === "object") {
          onChange(optionsData); // set new value
          setValidate(true);
        }
      } catch (e) {
        Sentry.captureException(e);
        Sentry.captureMessage(
          "Advanced settings JSON input could not be parsed."
        );
      }
    }
  };

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  }

  return (
    <Grid
      container
      item
      direction={"row"}
      sx={{
        alignItems: "center",
        flexWrap: "nowrap",
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      <Grid container item direction={"column"} rowSpacing={1}>
        <Grid item>
          <IgTypography style={{ marginRight: 15 }}>
            {toProperCaseWithSpaces(config.key)}:
          </IgTypography>
        </Grid>
        <Grid item>
          <Box
            sx={{
              border: "solid 1px #CBCBCB",
              marginRight: "10px",
            }}
          >
            <Editor
              height="300px"
              defaultLanguage="json"
              defaultValue={jsonData}
              onMount={handleEditorDidMount}
              onChange={(e) => {
                setJsonData(e || "");
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid item>
        <IgButton variant="outlined" onClick={parseOptionsInput}>
          {validate ? "Validated!" : "Validate"}
        </IgButton>
      </Grid>
    </Grid>
  );
};
